module.exports = __webpack_public_path__ + "img/1_22@2x.39ffea10.png";